import Moment from 'moment';
import { usePolicies } from '../../../hooks/queries/policies/usePolicies';
import { ALL_TEAM } from '../../../../teams/GlobalTeamsSelector';

/**
 *
 *
 * @param {string} accountId
 * @return {*} returns undefined if the query is still loading, otherwise returns a boolean indicating if the account has policies
 */
const useAccountHasPolicies = (accountId: string) => {
  const filter = {
    search: accountId,
    orderBy: 'timestamp',
    order: 'desc',
    size: 15,
    before: Moment().endOf('day').unix(),
    after: Moment('01-01-2020').unix(),
    teamIds: [ALL_TEAM.id],
  };

  const policiesQuery = usePolicies(filter);

  if (policiesQuery.data == null) {
    return undefined;
  }

  return policiesQuery.data.totalCount > 0;
};

export default useAccountHasPolicies;
